import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { AuthGuardService as AuthGuard } from './services/auth/auth-guard.service';

const routes: Routes = [
  { path: 'login', 
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule) 
  },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      // user UI
      {
        path: '',
        redirectTo: 'dashboard/orders',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./user/dashboard/dashboard.module').then((m) => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'errors',
        loadChildren: () => import('./user/errors/errors.module').then((m) => m.ErrorsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'order/:id',
        loadChildren: () => import('./user/order/order.module').then((m) => m.OrderModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'project/:id',
        loadChildren: () => import('./user/project/project.module').then((m) => m.ProjectModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'customer/:id',
        loadChildren: () => import('./user/customer/customer.module').then((m) => m.CustomerModule),
        canActivate: [AuthGuard],
      },
      // admin UI
      {
        path: 'administration',
        loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
        canActivate: [AuthGuard],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
